import React, { Component } from 'react';
import { UncontrolledCarousel,Jumbotron, Button, Spinner } from 'reactstrap';
import { observer, inject } from 'mobx-react';
import ReactGA from 'react-ga';

@inject("mobxStore")
@observer
export class Home extends Component {
    constructor (props) {
        super(props);

        props.mobxStore.getListingStats();

        this.items = [
            {
              src: '/images/Back of postcard.jpg?w=1024&h=1024&mode=max', altText: '', caption: '', header: ''
            },
            {
              src: '/images/Beachfront Land.jpg?w=1024&h=1024&mode=max', altText: '', caption: '', header: ''
            },
            {
              src: '/images/Waterfront Land.jpg?w=1024&h=1024&mode=max', altText: '', caption: '', header: ''
            },
            {
              src: '/images/Stump Pass Aerial.jpg?w=1024&h=1024&mode=max', altText: '', caption: '', header: ''
            },
            {
              src: '/images/491 N Gulf Postcard Photo.jpg?w=1024&h=1024&mode=max', altText: '', caption: '', header: ''
            },
            {
              src: '/images/121 N Gulf Blvd..jpg?w=1024&h=1024&mode=max', altText: '', caption: '', header: ''
            }
        ];
    }
    componentDidMount() {
        ReactGA.set({ page: 'Home' });
        ReactGA.pageview('/home');
    }

  render () {
    const {listingStats} = this.props.mobxStore;
    const publicUrl = process.env.PUBLIC_URL;

    return (
      <div>
        <UncontrolledCarousel className="carousel-fade" items={this.items} controls={false} slide={false} pause={false} interval={8000}></UncontrolledCarousel>

        { listingStats &&
            <div className="jumbo-section">
                <Jumbotron>
                    <div>
                        <div className="text-center">
                            <h3>Welcome to Kevin Mackin's site, the Palm Island Specialist!</h3>
                            <h4>There are currently a total of {listingStats.totalListings} Active Listings on the island.</h4>
                            <div className="d-flex justify-content-around mb-2">
                                <Button outline color="secondary" className="d-flex align-items-center" onClick={() => {window.location.href="/residential"}}>
                                    <img alt="Palm Island Specialist" src={`${publicUrl}/images/res_small.png`} className="img-fluid float-left pr-1" />
                                    <h6 className="d-inline pt-1">View {listingStats.totalRes} Residential Listings</h6>
                                </Button>
                                <Button outline color="secondary" className="d-flex align-items-center ml-1" onClick={() => {window.location.href="/land"}}>
                                    <img alt="Palm Island Specialist" src={`${publicUrl}/images/land_small.png`} className="img-fluid float-left pr-1" />
                                    <h6 className="d-inline pt-1">View {listingStats.totalLand} Land Listings</h6>
                                </Button>
                            </div>
                        </div>
                        <h4 className="text-center mt-3">OFF THE BEATEN PATH…BUT NOT TOO FAR OFF</h4>
                        <p>
                            Just moments off the beaten path, <strong>Palm Island</strong> also known as <strong>Don Pedro Island</strong> whisks you just far enough from the Florida mainland to leave traffic and crowds behind and welcome you to the peace and tranquility this island offers.  One of the last few bridgeless barrier islands in Florida, your new island paradise is never more than a five-minute car and pedestrian ferry ride away granting you both convenience and a calm lifestyle.
                        </p>
                        <p>
                            <img alt="Palm Island Specialist" src={`${publicUrl}/images/gopher.png`} className="img-fluid float-left pr-3" />
                            <strong>Palm Island</strong> lets you shake off your cares and re-invigorate your senses as you focus on your family, friends and pastimes you love the most like walking the beach, biking, shelling, fishing or simply watching the sunset with your loved ones.  Hugged on all sides by the finest remaining examples of “Old Florida” living, this island will keep you smiling in wondrous disbelief.  Laid back and yet luxurious, but surprisingly affordable.
                        </p>
                        <p>
                            After living on the island and selling real estate for over two decades, I hope you and your family will be able to come visit and enjoy the island as much as my wife, Charlene, and I do  Enjoy the quiet and kind serenity the island and its community awards to all visitors.  And, don’t hesitate to <a href="tel:941-769-0198" title="941 769 0198">give me a call</a> if you’d like more island information.  There are so many wonderful aspects to our little paradise and I’d be more than happy to help you foster a true appreciation of all this island offers.
                        </p>

						<h4 className="text-center">
                            It's easy to "get on island time" on Don Pedro and Palm Island!

                        </h4>
                        <div className="text-center">
                            <img alt="Palm Island Specialist" src={`${publicUrl}/images/manatee.png`} className="img-fluid" />
                        </div>
                    </div>

                </Jumbotron>
            </div>
        }
        { !listingStats &&
            <Spinner size="lg"/>
        }
      </div>


    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Home.jsx